// extracted by mini-css-extract-plugin
export default {"spinner":"OZnXs"};